import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
// import { ProjectInfo } from './projectinfo';
import { Observable } from 'rxjs/Rx';
import { AuthHttp, AuthConfig } from 'angular2-jwt';

import * as globals from '../globals';

@Injectable()
export class BernieService {

  private projectsUrl = globals.BERNIEAPIURL + '/projects';
  private projectsPageUrl = globals.BERNIEAPIURL + '/projects/page';
  private processUrl = this.projectsUrl + '/process';
  private processStatusUrl = this.processUrl + '/status';
  private translateUrl = this.projectsUrl + '/translate';
  private translateStatusUrl = this.translateUrl + '/status';
  private supportUrl = globals.BERNIEAPIURL + '/supportemail';
  private shareUrl = globals.BERNIEAPIURL + '/sharefile';

  constructor(private http: Http, public authHttp: AuthHttp) { }

  getProjects(): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ body: '', headers: headers });
    console.log('Projects: OPTIONS =>', options);
    console.log('URL:', this.projectsUrl);
    return this.authHttp.get(this.projectsUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getProjectsPage(currentPage: number, itemsPerPage: number) {
    let body = JSON.stringify({ currentPage: currentPage, itemsPerPage: itemsPerPage });
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let options = new RequestOptions({ body: body, headers: headers });
    console.log('Projects: OPTIONS =>', options);
    console.log('URL:', this.projectsPageUrl);
    // create the request, store the `Observable` for subsequent subscribers
    // this.projectobservable = this.authHttp.get(this.projectsUrl+'/page/'+ pagenum, options)
    return this.authHttp.post(this.projectsPageUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  startProcessingUpload(projectid: string, tenantid: string, filename: string, planid: string): Observable<string> {
    console.log('startProcessing service method called');

    let body = JSON.stringify({ projectid: projectid, tenantid: tenantid, filename: filename, planid: planid });
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ body: body, headers: headers });
    console.log('URL =>', this.processUrl);
    console.log('BODY =>', body);
    console.log('OPTIONS =>', options);

    return this.authHttp.post(this.processUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  deleteProject(id: any): Observable<string> {
    console.log('deleteProject service method called');

    let deleteUrl = this.projectsUrl + '/' + id;
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ body: '', headers: headers });
    // console.log('URL =>', deleteUrl);
    // console.log('OPTIONS =>', options);

    return this.authHttp.delete(deleteUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  processingUploadCheck(): Observable<string> {
    console.log('processingUploadCheck service called');
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ body: '', headers: headers });

    return this.authHttp.get(this.processStatusUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  sendSupportEmail(subject: string, message: string): Observable<string> {
    console.log('sendSupportEmail service method called');

    let body = JSON.stringify({ supportemail: { subject: subject, message: message } });
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });
    // console.log('URL =>', this.supportUrl);
    // console.log('OPTIONS =>', options);

    return this.authHttp.post(this.supportUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  share(sharedata: any): Observable<string> {
    console.log('share service method called');
    // console.log('sharedata:', sharedata);

    let body = JSON.stringify(sharedata);
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers, body: body });
    // console.log('URL =>', this.shareUrl);
    // console.log('OPTIONS =>', options);

    return this.authHttp.post(this.shareUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  translationCheck(tenantid: string, projectid: string): Observable<string> {
    console.log('translationCheck service called');
    let body = JSON.stringify({ tenantid: tenantid, projectid: projectid });
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });
    // console.log('URL =>', this.translateUrl);
    // console.log('BODY =>', body);
    // console.log('OPTIONS =>', options);

    return this.authHttp.post(this.translateStatusUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  addProject(file: Array<File>, type: number, projectdetails: any): Observable<string> {
    console.log('uploadProject service method called');
    console.log('Models name  : ' + projectdetails.projectname);
    console.log('File array count:', file.length);
    let body;
    if (!projectdetails.material) {
      projectdetails.material = 0;
    }
    if (!projectdetails.customerId) {
      projectdetails.customerId = 0;
    }
    if (!projectdetails.assignedId) {
      projectdetails.assignedId = 0;
    }
    let filenamenoext = file[0].name.replace(/\.[^/.]+$/, '');

    if (projectdetails.planid == 1) {
      body = JSON.stringify({
        model: {
          name: file[0].name,
          size: file[0].size,
          filename: file[0].name,
          modeltype_id: type
        },
        project: {
          name: file[0].name,
          model_id: 0
        }
      });
    }

    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });

    return this.authHttp.post(this.projectsUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  startTranslation(tenantid: string, projectid: string, filename: string, type: string): Observable<string> {
    console.log('startTranslation service method called');

    let body = JSON.stringify({ tenantid: tenantid, projectid: projectid, filename: filename, type: type });
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });
    // console.log('URL =>', this.translateUrl);
    // console.log('BODY =>', body);
    // console.log('OPTIONS =>', options);

    return this.authHttp.post(this.translateUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  private extractData(res: Response) {
    let body = res.json();
    // console.log('BODY:', body);
    return body || {};
  }

  handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    let errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error('CAUGHT AN ERROR:', errMsg); // log to console instead
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/bernie/bernie.service.ts